import Vue from 'vue';
import Vuex from 'vuex';
import user from './user';
import app from './app';
import locale from './locale';
import error from './error';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    user: user,
    app: app,
    locale: locale,
    error,
  },
});
